

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletContent from 'components/PortletContent';
import 'react-perfcascade/dist/react-perfcascade.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TablePagination from '@material-ui/core/TablePagination'
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Screenshot from '../../../../../helpers/Screenshot';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';

// Component styles
import { api_host , api_auth} from '../../../../../common/globals/constants';

import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

class ScreenshotElement extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            isLoad: true,
            objective: this.props.objective,
            nodes: this.props.nodes,
            steps: this.props.steps,
            begin: this.props.dateBegin,
            final: this.props.dateFinal,
            dates: null,
            modalOpen:false,
            monitors: this.props.monitors,
            node: this.props.node,
            isEmpty: false,
            service: this.props.service,
            listServicesMobile: [290, 292, 700],
            listServicesScreenshot: [255, 256, 257, 258, 270, 271, 272],
            pages: 1,
            page: 0, 
            rowsPerPage: 3,
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.dateBegin !== state.begin || props.dateFinal!==state.final) {
            return {
                isLoad: true,
                begin: props.dateBegin,
                final: props.dateFinal,
                dates: null
            }
        }
        if(props.node!== state.node){
            return {
                isLoad:true,
                nodes: props.nodes,
                monitors: props.monitors,
                node: props.node
            }
        }
        
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        //console.log('upd', prevProps.dateBegin.format("YYYY-MM-DD H:mm:ss"), this.state.begin)
        if(prevProps.dateBegin!== this.state.begin || prevProps.dateFinal!== this.state.final||
            prevProps.node !== this.state.node){
            this.processData();
        }
    }
    

    componentDidMount() {
        this.processData();
    }

    getFetchs = (objective, begin, final, monitores, token, service) =>{
        //console.log('getfetch')
        return new Promise((resolve, reject) => {
            var cdnList = []
            var fetches = []            
            monitores.forEach((value, key)=>{
                var monitor_id=(value)
                var getListScreenshot = fetch(api_host+`/reporte/general/objetivos/${objective}/screenshots/list_images_thumbnail/?token=${token}&fecha_inicio=${begin}&fecha_termino=${final}&monitor=${monitor_id}&service=${service}`)
                        .then( response => response.json())
                fetches.push(                    
                    getListScreenshot.then( dataCdn =>  { 
                            cdnList[key] = dataCdn;
                    })                    
                )
            })
            Promise.all(fetches).then(() => {
                resolve(cdnList);
            })      
        });
    }

   
    processData = () => {
        //console.log('process')
        const { objective, nodes, begin, final, monitors, node, service} = this.state
        let token = sessionStorage.getItem('key')
        let listImage = []
        //let beginTitle = String(event.currentTarget.id).substring(0,19)
        //let endTitle = String(event.currentTarget.id).substring(19,38)
        //let targetEvent = event.currentTarget
        //let currentNode = event.currentTarget.value
        fetch(api_host+`/reporte/online/indicadores/getResultadosObjetivoLigero/?objetivoId=${objective}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&horarioId=0&fecha_inicio=${begin}&fecha_termino=${final}&nodoId=${node}`)
                .then(response => response.json())
                .then(myJson => { 
                    //if (target !== event.currentTarget){
                        var listMonitor = monitors
                        if (node != 0){
                            listMonitor = []
                            Object(nodes).map(element=>{
                                if (element['id_nodo'] == node){
                                    listMonitor.push(element['monitor'])
                                }
                            })
                        }
                        let nodesStatus = myJson.Objetivo.Nodo
                        var fetchListScreenshot = this.getFetchs(objective, begin, final, listMonitor, token, service)
                        
                        fetchListScreenshot.then( value =>{
                            Object(value).map(element=>{
                                if (element.length > 0){
                                    Object(element).map(data=>{
                                        listImage.push(data)
                                    })
                                }
                            })
                            var isEmpty = false
                            var contimages = 0
                            if (listImage.length > 0) {
                            
                                listImage.sort(function (a, b) {
                                    const aDate = new Date(a.fecha_creacion)
                                    const bDate = new Date(b.fecha_creacion)
                                    return bDate.getTime() - aDate.getTime()
                                });
                                Object(listImage).map(element=>{
                                    Object(nodes).map(node=>{
                                        if(node['monitor'] == element['monitor_id']){
                                            element['nodo'] = node['nodo']
                                            Object(nodesStatus).map(nodeStatus=>{
                                                if (nodeStatus['nodo_id'] == node['id_nodo']){
                                                    let listStatus = []
                                                    let listPattern = []
                                                    let listStep = []
                                                    let listStepId = []
                                                    var index = 0
                                                    Object(nodeStatus['Paso']).map(stepStatus=>{
                                                        var pattern = null
                                                        Object(stepStatus['Eventos']).map(eventStatus=>{
                                                            pattern = eventStatus.patron
                                                            const dateEventStatus = new Date(eventStatus.fecha.substring(0,19))
                                                            const dateElement = new Date(element.fecha_creacion)
                                                            if (element['monitor_id']==2261 && stepStatus['orden']==9){
                                                            }
                                                            if (dateElement.getTime() - dateEventStatus.getTime() > -1000){
                                                                listStatus[index] = eventStatus['código_tipo']
                                                            }
                                                        })
                                                        listPattern.push(pattern)
                                                        listStep.push(stepStatus['paso_nombre'])
                                                        listStepId.push(stepStatus['orden'])
                                                        index = index + 1
                                                    })
                                                    element['pattern'] = listPattern
                                                    element['status'] = listStatus
                                                    element['steps'] = listStep
                                                    element['stepsId'] = listStepId
                                                }
                                            })
                                        }
                                    })
                                })
                                var listImageFilter = []
                                Object(listImage).map(element=>{
                                    var listImageToken = []
                                    var listColorStatus = []
                                    var listStepsWithScreenshots = []
                                    var listStepsIdWithScreenshots = []
                                    var listPatternWithScreenshot = []
                                    var listTokenSteps = []
                                    Object(element['img_token']).map((imgToken, key)=>{
                                        var color = ''
                                        if (imgToken != 'NULL'){
                                            Object(element['stepsId']).map((stepId, orden)=>{
                                                if(stepId == key) {
                                                    const byteCharacters = atob(element['img_token'][key]);
                                                    const byteNumbers = new Array(byteCharacters.length);
                                                    for (let i = 0; i < byteCharacters.length; i++) {
                                                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                                                    }
                                                    const byteArray = new Uint8Array(byteNumbers);
                
                                                    let image = new Blob([byteArray], { type: 'image/jpeg' });
                                                    let imageUrl = URL.createObjectURL(image);
                                                    listImageToken.push(imageUrl)
                                                    if(element['status'][orden] == 0){
                                                        color = '#A9A9A9'
                                                    }else if(element['status'][orden] == 1) {
                                                        color = '#41B900'
                                                    }else if(element['status'][orden] == 2) {
                                                        color = '#C2272D'
                                                    }
                                                    listColorStatus.push(color)
                                                    listStepsWithScreenshots.push(element['steps'][orden])
                                                    listStepsIdWithScreenshots.push(element['stepsId'][orden])
                                                    listPatternWithScreenshot.push(element['pattern'][orden])
                                                    listTokenSteps.push(element['tokens'][key])
                                                }
                                            })
                                            

                                            
                                        } /*else {
                                            element['steps'].splice(key, 1)
                                        }*/
                                        
                                    })
                                    element['images'] = listImageToken
                                    element['color'] = listColorStatus
                                    element['stepsWithScreenshots'] = listStepsWithScreenshots
                                    element['stepsIdWithScreenshots'] = listStepsIdWithScreenshots
                                    element['tokenSteps'] = listTokenSteps
                                    element['patternWithScreenshot'] = listPatternWithScreenshot
                                    if (listImageToken.length == 0){
                                        contimages = contimages + 1
                                    }
                                    if (listImageToken.length > 0){
                                        listImageFilter.push(element)
                                    }
                                })
                            } else {
                                isEmpty = true
                            }
                            if (contimages == listImage.length){
                                isEmpty = true
                            }
                            this.props.callbackFromParent(true)
                            this.setState({ isOpen: !this.state.isOpen,
                                            //target: targetEvent,
                                            currentDate: begin,
                                            //currentNode: currentNode,
                                            isEmpty: isEmpty,
                                            listImage: listImage,
                                            listImageFilter: listImageFilter,
                                            isLoad: false,
                                            dates: value});
                        })

                })
        
    }

    setOpen = ( ele, tokenPicture, stepToken, dateBeginScreenshot, pattern) => {
        this.setState({
            modalOpen : true,
            modalClose : false,
            tokenPicture : tokenPicture,
            stepToken : stepToken,
            nameStep : ele,
            dateBeginScreenshot: dateBeginScreenshot,
            pattern: pattern
        })
    }
    setCloseModal=()=>{
        this.setState({
            modalOpen : false,
            modalClose : true
        })
    }

    handleChangePage = (e, page)=>{
        this.setState({
            page : page
        })
    }

    render() {

        const { isLoad, dates, steps, objective, image, listImage, modalOpen, isEmpty, listServicesMobile, listServicesScreenshot, service, rowsPerPage, page, listImageFilter} = this.state;
        const { classes } = this.props;
        var style = {borderTop: '1px solid #ddd', borderRadius: '4px', padding: '5px', height:'150px', width:'194px'} 
        if (listServicesMobile.includes(service)){
            style = {borderTop: '1px solid #ddd', borderRadius: '4px', padding: '5px', height:'150px'} 
        }
        if (isLoad===true) {
            return(
                <div className={classes.chart}>
                    <Typography
                        variant="caption"
                        align="center"
                        style={{color:'white'}}
                    >
                        <CircularProgress
                            variant="indeterminate"
                            size={12}
                            thickness={3}
                        />
                        Cargando Información...
                    </Typography>
                </div>
            )
        }else{
            return(
                <PortletContent style={{textAlign: 'center', width: isEmpty ? '30vw' : '60vw'}}>
                    {isEmpty ? <Typography
                                    variant="caption"
                                    align="center"
                                    style={{color:'white'}}
                                >
                                     No existen screenshots</Typography>
                        
                    :listImageFilter
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map(element=>{
                        return(
                            <div key={element['nodo']+'    '+element['fecha_creacion'].replace('T',' ')}>
                                <PortletHeader style={{backgroundColor:'#525252', color:'white', fontFamily:'Roboto'}}>
                                    {element['nodo']+'    '+element['fecha_creacion'].replace('T',' ')}
                                </PortletHeader>
                                <PortletContent style={{backgroundColor: '#a2a2a2'}} >
                                    <PerfectScrollbar > 
                                        <TableRow
                                            //direction="row"
                                            //container
                                            //spacing={2}
                                            //justify="flex-start"
                                            style={{textOverflow: 'ellipsis',
                                            overflow: 'hidden',
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            width: '500% !important',}}
                                        >
                                            {element['images'].map((image, key)=>(
                                                <TableCell key={element['tokenSteps'][key]}>
                                                    <Button onClick={(e)=>{this.setOpen(element['stepsWithScreenshots'][key], element['tokenSteps'][key], element['stepsIdWithScreenshots'][key], element['fecha_creacion'], element['patternWithScreenshot'][key])}}>
                                                        <div style={{border: '1px solid #ddd', width: '214px'}}>
                                                            <Typography style={{backgroundColor: element['color'][key], color:'white', fontFamily: "Roboto, Helvetica, Arial, sans-serif", padding: '5px'}}>{element['stepsWithScreenshots'][key]}</Typography>
                                                            <img style={style} src={image} />
                                                        </div>
                                                    </Button>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </PerfectScrollbar>
                                </PortletContent>
                            </div>
                        )
                    })}
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={modalOpen}
                        onClose={this.setCloseModal}
                        style={{
                            //maxHeight:'40vh',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 100,
                        }}               
                    >
                        <Fade in={modalOpen}>
                            <Screenshot data = {this.state}  onClose={this.setCloseModal}/>
                        </Fade>
                    </Modal>
                    <TablePagination
                            style={{color:"white", backgroundColor:"#525252"}}
                            rowsPerPageOptions={[6]}
                            component="div"
                            count={listImageFilter ? listImageFilter.length : 0}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            labelDisplayedRows={({ from, to, count }) => {return '' + from + '-' + to + ' de ' + count}}
                            backIconButtonProps={{
                                'aria-label': 'previous page',
                                'style': {'color': 'white'}
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'next page',
                                'style': {'color': 'white'}
                            }}
                            onChangePage={this.handleChangePage}/>
                </PortletContent>
                
                
                
            )
        }
    }
}



export default compose(withRouter, withStyles(styles))(ScreenshotElement);